import { Component, inject, OnInit } from '@angular/core';

// interfaces
import { PageComponent } from '@sideline/sideline-apps-shared';

// services
import { AuthService, PageService } from '@sideline/sideline-apps-shared';

// components
import { NotAllowedContent } from '../../components/not-allowed-content/not-allowed-content';
import { PublicLayout } from '../../../../layouts/public/layout/public.layout';
import { PublicPage } from "../../../../layouts/public/components/public-page/public-page";

@Component({
  selector: 'app-not-allowed-page',
  templateUrl: './not-allowed-page.html',
  styleUrl: './not-allowed-page.scss',
  standalone: true,
  imports: [
    NotAllowedContent,
    PublicLayout,
    PublicPage,
  ]
})
export class NotAllowedPage implements PageComponent, OnInit {

  title: string = 'Not Allowed';
  authenticated: boolean = false;

  // services
  private authService = inject(AuthService);
  pageService = inject(PageService);

  ngOnInit(): void {
    this.authenticated = this.authService.isAuthenticated();
    this.pageService.setTitle(this.title);
  }

}
